"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server response from a GET_SESSION_PROPERTIES request.
 */
var GetSessionPropertiesResponse = /** @class */ (function () {
    /**
     * Create a new GetSessionPropertiesResponse instance
     *
     * @param properties  the session properties
     */
    function GetSessionPropertiesResponse(properties) {
        this.properties = properties;
    }
    /**
     * Convert object to string
     *
     * @return  a string representation of the GetSessionPropertiesResponse object
     */
    GetSessionPropertiesResponse.prototype.toString = function () {
        return 'GetSessionPropertiesResponse []';
    };
    return GetSessionPropertiesResponse;
}());
exports.GetSessionPropertiesResponse = GetSessionPropertiesResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/get-session-properties-response.js
// module id = 1892
// module chunks = 1